import { CodigosTransaccionesConstant } from 'constants/index'

const menuConfig = [
  {
    title: 'Activos Fijos',
    submenu: [
      {
        title: 'Activos Fijos',
        page: CodigosTransaccionesConstant.ACTIVOSFIJOS_LISTA,
        transaccion: CodigosTransaccionesConstant.ACTIVOSFIJOS_LISTA
      },
      {
        title: 'Bajas',
        page: CodigosTransaccionesConstant.ACTIVOSFIJOS_BAJAS_LISTA,
        transaccion: CodigosTransaccionesConstant.ACTIVOSFIJOS_BAJAS_LISTA
      },
      {
        title: 'Inventarios Físicos',
        page: CodigosTransaccionesConstant.ACTIVOSFIJOS_INVENTARIOS_LISTA,
        transaccion: CodigosTransaccionesConstant.ACTIVOSFIJOS_INVENTARIOS_LISTA
      },
      {
        title: 'Reportes',
        page: CodigosTransaccionesConstant.ACTIVOSFIJOS_REPORTES,
        transaccion: CodigosTransaccionesConstant.ACTIVOSFIJOS_REPORTES
      }
    ]
  },
  {
    title: 'Asientos Contables',
    submenu: [
      {
        title: 'Asientos Contables',
        page: CodigosTransaccionesConstant.ASIENTOSCONTABLES_LISTA,
        transaccion: CodigosTransaccionesConstant.ASIENTOSCONTABLES_LISTA
      },
      {
        title: 'No Domiciliados',
        page: CodigosTransaccionesConstant.ASIENTOSCONTABLES_NODOMICILIADOS,
        transaccion: CodigosTransaccionesConstant.ASIENTOSCONTABLES_NODOMICILIADOS
      },
      {
        title: 'Reportes',
        submenu: [
          {
            title: 'Balance de Comprob.',
            page: CodigosTransaccionesConstant.ASIENTOSCONTABLES_REPORTES_BALANCECOMPROBACION,
            transaccion: CodigosTransaccionesConstant.ASIENTOSCONTABLES_REPORTES_BALANCECOMPROBACION
          },
          {
            title: 'Análisis de Balance',
            page: CodigosTransaccionesConstant.ASIENTOSCONTABLES_REPORTES_ANALISISBALANCE,
            transaccion: CodigosTransaccionesConstant.ASIENTOSCONTABLES_REPORTES_ANALISISBALANCE
          },
          {
            title: 'Registro Compras',
            page: CodigosTransaccionesConstant.ASIENTOSCONTABLES_REPORTES_REGISTROCOMPRAS,
            transaccion: CodigosTransaccionesConstant.ASIENTOSCONTABLES_REPORTES_REGISTROCOMPRAS
          },
          {
            title: 'Registro Ventas',
            page: CodigosTransaccionesConstant.ASIENTOSCONTABLES_REPORTES_REGISTROVENTAS,
            transaccion: CodigosTransaccionesConstant.ASIENTOSCONTABLES_REPORTES_REGISTROVENTAS
          },
          {
            title: 'Registro de Provee.',
            page: CodigosTransaccionesConstant.ASIENTOSCONTABLES_REPORTES_REGISTROPROVEEDORES,
            transaccion: CodigosTransaccionesConstant.ASIENTOSCONTABLES_REPORTES_REGISTROPROVEEDORES
          },
          {
            title: 'Reporte de Detracc.',
            page: CodigosTransaccionesConstant.ASIENTOSCONTABLES_REPORTES_DETRACCIONES,
            transaccion: CodigosTransaccionesConstant.ASIENTOSCONTABLES_REPORTES_DETRACCIONES
          },
          {
            title: 'Libro Diario',
            page: CodigosTransaccionesConstant.ASIENTOSCONTABLES_REPORTES_LIBRODIARIO,
            transaccion: CodigosTransaccionesConstant.ASIENTOSCONTABLES_REPORTES_LIBRODIARIO
          },
          {
            title: 'Libro Mayor',
            page: CodigosTransaccionesConstant.ASIENTOSCONTABLES_REPORTES_LIBROMAYOR,
            transaccion: CodigosTransaccionesConstant.ASIENTOSCONTABLES_REPORTES_LIBROMAYOR
          },
          {
            title: 'Libro Anexos',
            page: CodigosTransaccionesConstant.ASIENTOSCONTABLES_REPORTES_LIBROANEXOS,
            transaccion: CodigosTransaccionesConstant.ASIENTOSCONTABLES_REPORTES_LIBROANEXOS
          },
          {
            title: 'Libro Auxiliar',
            page: CodigosTransaccionesConstant.ASIENTOSCONTABLES_REPORTES_LIBROAUXILIAR,
            transaccion: CodigosTransaccionesConstant.ASIENTOSCONTABLES_REPORTES_LIBROAUXILIAR
          },
          {
            title: 'Libro Caja-Bancos',
            page: CodigosTransaccionesConstant.ASIENTOSCONTABLES_REPORTES_LIBROCAJABANCOS,
            transaccion: CodigosTransaccionesConstant.ASIENTOSCONTABLES_REPORTES_LIBROCAJABANCOS
          },
          {
            title: 'Consistencias',
            page: CodigosTransaccionesConstant.ASIENTOSCONTABLES_REPORTES_CONSISTENCIAS,
            transaccion: CodigosTransaccionesConstant.ASIENTOSCONTABLES_REPORTES_CONSISTENCIAS
          }
        ]
      },
      {
        title: 'Libros Electrónicos',
        submenu: [
          {
            title: 'Registro Compras',
            page: CodigosTransaccionesConstant.ASIENTOSCONTABLES_LIBROELECTRONICO_REGISTROCOMPRAS,
            transaccion: CodigosTransaccionesConstant.ASIENTOSCONTABLES_LIBROELECTRONICO_REGISTROCOMPRAS
          },
          {
            title: 'Registro Ventas',
            page: CodigosTransaccionesConstant.ASIENTOSCONTABLES_LIBROELECTRONICO_REGISTROVENTAS,
            transaccion: CodigosTransaccionesConstant.ASIENTOSCONTABLES_LIBROELECTRONICO_REGISTROVENTAS
          },
          {
            title: 'Libro Diario',
            page: CodigosTransaccionesConstant.ASIENTOSCONTABLES_LIBROELECTRONICO_LIBRODIARIO,
            transaccion: CodigosTransaccionesConstant.ASIENTOSCONTABLES_LIBROELECTRONICO_LIBRODIARIO
          },
          {
            title: 'Libro Mayor',
            page: CodigosTransaccionesConstant.ASIENTOSCONTABLES_LIBROELECTRONICO_LIBROMAYOR,
            transaccion: CodigosTransaccionesConstant.ASIENTOSCONTABLES_LIBROELECTRONICO_LIBROMAYOR
          },
          {
            title: 'Libro RVIE',
            page: CodigosTransaccionesConstant.ASIENTOSCONTABLES_LIBROELECTRONICO_RVIE,
            transaccion: CodigosTransaccionesConstant.ASIENTOSCONTABLES_LIBROELECTRONICO_RVIE
          }
        ]
      },
      {
        title: 'Importar',
        page: CodigosTransaccionesConstant.ASIENTOSCONTABLES_IMPORTAR,
        transaccion: CodigosTransaccionesConstant.ASIENTOSCONTABLES_IMPORTAR
      },
      {
        title: 'Utiles',
        page: CodigosTransaccionesConstant.ASIENTOSCONTABLES_UTILES,
        transaccion: CodigosTransaccionesConstant.ASIENTOSCONTABLES_UTILES
      },
      {
        title: 'Consultas',
        submenu: [
          {
            title: 'Documentos',
            page: CodigosTransaccionesConstant.ASIENTOSCONTABLES_CONSULTA_DOCUMENTOS,
            transaccion: CodigosTransaccionesConstant.ASIENTOSCONTABLES_CONSULTA_DOCUMENTOS
          },
          {
            title: 'Cuentas corrientes',
            page: CodigosTransaccionesConstant.ASIENTOSCONTABLES_CONSULTA_CUENTACORRIENTE,
            transaccion: CodigosTransaccionesConstant.ASIENTOSCONTABLES_CONSULTA_CUENTACORRIENTE
          }
        ]
      },
      {
        title: 'SIRE - Reportes',
        page: CodigosTransaccionesConstant.ASIENTOSCONTABLES_SIRE_REPORTES,
        transaccion: CodigosTransaccionesConstant.ASIENTOSCONTABLES_SIRE_REPORTES
      }
    ]
  },
  // {
  //   title: 'Presupuesto',
  //   page: CodigosTransaccionesConstant.PRESUPUESTOS_LISTA,
  //   transaccion: CodigosTransaccionesConstant.PRESUPUESTOS_LISTA
  // },
  {
    title: 'Presupuesto',
    submenu: [
      {
        title: 'Gestionar',
        page: CodigosTransaccionesConstant.PRESUPUESTOS_LISTA,
        transaccion: CodigosTransaccionesConstant.PRESUPUESTOS_LISTA
      },
      {
        title: 'Reportes',
        page: CodigosTransaccionesConstant.PRESUPUESTOS_REPORTES,
        transaccion: CodigosTransaccionesConstant.PRESUPUESTOS_REPORTES
      }
    ]
  },
  {
    title: 'Libros Electronicos PRICOS',
    submenu: [
      {
        title: 'Caja - Bancos',
        page: CodigosTransaccionesConstant.LIBROSELECTRONICOS_CAJABANCOS,
        transaccion: CodigosTransaccionesConstant.LIBROSELECTRONICOS_CAJABANCOS
      }
    ]
  },
  {
    title: 'Costos',
    submenu: [
      {
        title: 'Centros Costo',
        page: CodigosTransaccionesConstant.CENTROSCOSTO_LISTA,
        transaccion: CodigosTransaccionesConstant.CENTROSCOSTO_LISTA
      },
      {
        title: 'Factores de Costos',
        page: CodigosTransaccionesConstant.FACTORESCOSTOSINDIRECTOS_MAIN,
        transaccion: CodigosTransaccionesConstant.FACTORESCOSTOSINDIRECTOS_MAIN
      },
      {
        title: 'Reportes',
        page: CodigosTransaccionesConstant.CENTROSCOSTO_REPORTES,
        transaccion: CodigosTransaccionesConstant.CENTROSCOSTO_REPORTES
      }
    ]
  },
  // {
  //   title: 'Presupuestos',
  //   submenu: [
  //     {
  //       title: 'Presupuestos',
  //       page: CodigosTransaccionesConstant.PRESUPUESTOS_MAIN,
  //       transaccion: CodigosTransaccionesConstant.PRESUPUESTOS_MAIN
  //     },
  //     {
  //       title: 'Presupuestos - Asignacion',
  //       page: CodigosTransaccionesConstant.PRESUPUESTOS_ASIGNACION,
  //       transaccion: CodigosTransaccionesConstant.PRESUPUESTOS_ASIGNACION
  //     },
  //     {
  //       title: 'Proyectos',
  //       page: CodigosTransaccionesConstant.PROYECTOS_LISTA,
  //       transaccion: CodigosTransaccionesConstant.PROYECTOS_LISTA
  //     }
  //   ]
  // },
  {
    title: 'Estados Financieros',
    submenu: [
      {
        title: 'Balance General',
        page: CodigosTransaccionesConstant.ESTADOSFINANCIEROS_BALANCEGENERAL,
        transaccion: CodigosTransaccionesConstant.ESTADOSFINANCIEROS_BALANCEGENERAL
      },
      {
        title: 'Balance Sunat',
        submenu: [
          {
            title: 'PLE Anual',
            page: CodigosTransaccionesConstant.ESTADOSFINANCIEROS_BALANCESUNAT_PLEANUAL,
            transaccion: CodigosTransaccionesConstant.ESTADOSFINANCIEROS_BALANCESUNAT_PLEANUAL
          }
        ]
      },
      {
        title: 'Reportes',
        page: CodigosTransaccionesConstant.ESTADOSFINANCIEROS_REPORTE,
        transaccion: CodigosTransaccionesConstant.ESTADOSFINANCIEROS_REPORTE
      },
      {
        title: 'Cierre clase 6-7-9',
        page: CodigosTransaccionesConstant.ESTADOSFINANCIEROS_CIERRECLASE679,
        transaccion: CodigosTransaccionesConstant.ESTADOSFINANCIEROS_CIERRECLASE679
      }
    ]
  },
  {
    title: 'Estructuras De Balance',
    page: CodigosTransaccionesConstant.ESTRUCTURASBALANCE_LISTA,
    transaccion: CodigosTransaccionesConstant.ESTRUCTURASBALANCE_LISTA
  },
  {
    title: 'Fondo Fijo',
    submenu: [
      {
        title: 'Reportes',
        page: CodigosTransaccionesConstant.FONDOFIJO_REPORTES,
        transaccion: CodigosTransaccionesConstant.FONDOFIJO_REPORTES
      }
    ]
  },
  {
    title: 'Caja Chica',
    submenu: [
      {
        title: 'Sólo Trabajadores - Titulo Viatico',
        page: CodigosTransaccionesConstant.CAJACHICA_SOLO_TRABAJADORES_VIATICO,
        transaccion: CodigosTransaccionesConstant.CAJACHICA_SOLO_TRABAJADORES_VIATICO
      },
      {
        title: 'Trabajador - Titulo Viatico',
        page: CodigosTransaccionesConstant.CAJACHICA_TRABAJADOR_VIATICO,
        transaccion: CodigosTransaccionesConstant.CAJACHICA_TRABAJADOR_VIATICO
      },
      {
        title: 'Sólo Trabajadores - Asignar Documentos',
        page: CodigosTransaccionesConstant.CAJACHICA_SOLO_TRABAJADORES_ASIGNAR_DOCUMENTOS,
        transaccion: CodigosTransaccionesConstant.CAJACHICA_SOLO_TRABAJADORES_ASIGNAR_DOCUMENTOS
      },
      {
        title: 'Asignar Documentos',
        page: CodigosTransaccionesConstant.CAJACHICA_ASIGNAR_DOCUMENTOS,
        transaccion: CodigosTransaccionesConstant.CAJACHICA_ASIGNAR_DOCUMENTOS
      },
      {
        title: 'Registrar Trabajadores',
        page: CodigosTransaccionesConstant.CAJACHICA_REGISTRAR_TRABAJADORES_LISTA,
        transaccion: CodigosTransaccionesConstant.CAJACHICA_REGISTRAR_TRABAJADORES_LISTA
      }
    ]
  },
  {
    title: 'Mayorizacion',
    page: CodigosTransaccionesConstant.MAYORIZACION_MAIN,
    transaccion: CodigosTransaccionesConstant.MAYORIZACION_MAIN
  },
  {
    title: 'Procesos BG',
    page: CodigosTransaccionesConstant.BACKGROUNDJOBS_MAIN,
    transaccion: CodigosTransaccionesConstant.BACKGROUNDJOBS_MAIN
  },
  {
    title: 'Plan Contable',
    page: CodigosTransaccionesConstant.PLANCONTABLE_MAIN,
    transaccion: CodigosTransaccionesConstant.PLANCONTABLE_MAIN
  },
  {
    title: 'Mantenimiento',
    submenu: [
      {
        title: 'Bloqueo Periodos',
        page: CodigosTransaccionesConstant.BLOQUEOSPERIODOS_MAIN,
        transaccion: CodigosTransaccionesConstant.BLOQUEOSPERIODOS_MAIN
      },
      {
        title: 'Compañia',
        submenu: [
          {
            title: 'Compañia',
            page: CodigosTransaccionesConstant.COMPANIA_MAIN,
            transaccion: CodigosTransaccionesConstant.COMPANIA_MAIN
          },
          {
            title: 'Nueva',
            page: CodigosTransaccionesConstant.COMPANIA_NUEVO,
            transaccion: CodigosTransaccionesConstant.COMPANIA_NUEVO
          }
        ]
      },
      {
        title: 'Socios',
        page: CodigosTransaccionesConstant.SOCIOS_LISTA,
        transaccion: CodigosTransaccionesConstant.SOCIOS_LISTA
      },
      {
        title: 'Plantillas',
        page: CodigosTransaccionesConstant.PLANTILLASCONTABILIDAD_LISTA,
        transaccion: CodigosTransaccionesConstant.PLANTILLASCONTABILIDAD_LISTA
      },
      {
        title: 'Plantillas Generales',
        page: CodigosTransaccionesConstant.PLANTILLASGENERALESCONTABILIDAD_LISTA,
        transaccion: CodigosTransaccionesConstant.PLANTILLASGENERALESCONTABILIDAD_LISTA
      },
      {
        title: 'Tablas Comunes',
        page: CodigosTransaccionesConstant.TABLASCOMUNES_MAIN,
        transaccion: CodigosTransaccionesConstant.TABLASCOMUNES_MAIN
      },
      {
        title: 'Glosas',
        page: CodigosTransaccionesConstant.GLOSASCONTABILIDAD_LISTA,
        transaccion: CodigosTransaccionesConstant.GLOSASCONTABILIDAD_LISTA
      },
      {
        title: 'Usuarios',
        page: CodigosTransaccionesConstant.USUARIOS_LISTA,
        transaccion: CodigosTransaccionesConstant.USUARIOS_LISTA
      },
      {
        title: 'Roles',
        page: CodigosTransaccionesConstant.ROLES_LISTA,
        transaccion: CodigosTransaccionesConstant.ROLES_LISTA
      }
    ]
  }
]

export default menuConfig
